import React from 'react';
import { Fragment } from 'react';
const Spinner = () => {
	return (
		<Fragment>		
				<div className="loading">Loading&#8230;
				</div>		
		</Fragment>
	);
}
export default Spinner;